import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row research-items-container iodine-padding-left-sm iodine-padding-right-sm" }
const _hoisted_2 = { class: "research-items-more row iodine-padding-top-sm iodine-padding-left-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_research_item = _resolveComponent("research-item")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_ctx.researchSectionDataModel)
    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
        key: 0,
        class: "io-mfe-ig-expansion-item",
        "model-value": _ctx.hasItems
      }, {
        header: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "research-section-title" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.researchSectionDataModel?.title), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_list, { dense: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.researchSectionDataModel?.coding_advices, (item) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_research_item, { "research-item-data-model": item }, null, 8, ["research-item-data-model"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showArticles(_ctx.researchSectionDataModel.articles, true), (item) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_research_item, { "research-item-data-model": item }, null, 8, ["research-item-data-model"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showArticles(_ctx.researchSectionDataModel.articles, false), (item) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_research_item, { "research-item-data-model": item }, null, 8, ["research-item-data-model"])
                    ]),
                    _: 2
                  }, 1024)), [
                    [_vShow, _ctx.othersExpanded]
                  ])
                }), 128)),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                  _withDirectives(_createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.othersExpanded = true))
                  }, [
                    _createTextVNode(" Show All Matches (" + _toDisplayString(_ctx.researchSectionDataModel?.best_count + _ctx.researchSectionDataModel.other_count) + ")   ", 1),
                    _createVNode(_component_q_icon, {
                      name: "fa-solid fa-angle-down",
                      class: "iodine-small-icon"
                    })
                  ], 512), [
                    [_vShow, !_ctx.othersExpanded]
                  ]),
                  _withDirectives(_createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.othersExpanded = false))
                  }, [
                    _createTextVNode(" Show Top Matches Only (" + _toDisplayString(_ctx.researchSectionDataModel.best_count) + ")   ", 1),
                    _createVNode(_component_q_icon, {
                      name: "fa-solid fa-angle-up",
                      class: "iodine-small-icon"
                    })
                  ], 512), [
                    [_vShow, _ctx.othersExpanded]
                  ])
                ], 512), [
                  [_vShow, _ctx.researchSectionDataModel.other_count > 0]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model-value"]))
    : _createCommentVNode("", true)
}